import { render } from "./UiSpinner.vue?vue&type=template&id=04c96a65"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiSpinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04c96a65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04c96a65', __exports__)) {
    api.reload('04c96a65', __exports__)
  }
  
  module.hot.accept("./UiSpinner.vue?vue&type=template&id=04c96a65", () => {
    api.rerender('04c96a65', render)
  })

}


export default __exports__